import { render, staticRenderFns } from "./TerminosDirectoComponent.vue?vue&type=template&id=7e9e7c80&"
import script from "./TerminosDirectoComponent.vue?vue&type=script&lang=ts&"
export * from "./TerminosDirectoComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports